import { createFileRoute } from '@tanstack/react-router';

import QuoteRequestsPage from '@/areas/quote-requests/QuoteRequests/QuoteRequestsPage/QuoteRequestsPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { projectId } = Route.useParams();
    return <QuoteRequestsPage context={{ type: 'Rfq', id: projectId }} />;
}
